import {
  GET_TRANSFER_LINE_STORE_REQUEST,
  GET_TRANSFER_LINE_RESET_REQUEST,
  GET_TRANSFER_OPTION_FAILURE,
  GET_TRANSFER_OPTION_REQUEST,
  GET_TRANSFER_OPTION_SUCCESS,
  GET_TRANSFER_LINE_DETAIL_INSTRUCTION_FAILURE,
  GET_TRANSFER_LINE_DETAIL_INSTRUCTION_REQUEST,
  GET_TRANSFER_LINE_DETAIL_INSTRUCTION_SUCCESS,
  GET_TRANSFER_LINE_ORDER_SUBMIT_FAILURE,
  GET_TRANSFER_LINE_ORDER_SUBMIT_REQUEST,
  GET_TRANSFER_LINE_ORDER_SUBMIT_SUCCESS,
  TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_FAILURE,
  TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_SUCCESS,
  TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_FAILURE,
  TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_SUCCESS,
  TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_FAILURE,
  TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_SUCCESS,
  GET_TRANSFER_LINE_PERSONAL_PLANS_REQUEST,
  GET_TRANSFER_LINE_PERSONAL_PLANS_SUCCESS,
  GET_TRANSFER_LINE_PERSONAL_PLANS_FAILURE
} from "@/actions/transferline/actionTypes";

export const initialState = {
  isSaving: false,
  transferLineOption: {},
  transferlineDetail: {},
  isSuccessDetail: false,
  formDataDetail: {},
  termsAndConditions: {},
  instructionsSet: {},
  orderDetail: {},
  orderTime: 0,
  detailRequest: {},
  isLoading: false,
  errorDocuments: '',
  documentRepo: {},
  personalPlans: []
};

export const PROFILE_ERROR_CODE = {
  'INTERNAL-SERVER-ERROR': 'PROFILE_ERROR_INTERNAL_SERVER',
  'PROFILE-NOT-FOUND': 'PROFILE_ERROR_NOT_FOUND',
  'INVALID-DOCUMENT-ID': 'PROFILE_ERROR_INVALID_DOCUMENT_ID',
  'INVALID-FILE-TYPE': 'PROFILE_ERROR_INVALID_FILE_TYPE',
  'INVALID-FILE-SIZE': 'PROFILE_ERROR_INVALID_FILE_SIZE'
};

const transferLineReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSFER_OPTION_REQUEST:
    case GET_TRANSFER_OPTION_FAILURE:
    case GET_TRANSFER_LINE_ORDER_SUBMIT_REQUEST:
    case GET_TRANSFER_LINE_ORDER_SUBMIT_FAILURE:
      return {
        ...state
      };
    case GET_TRANSFER_OPTION_SUCCESS:
      return {
        ...state,
        transferLineOption: action.data
      };
    case GET_TRANSFER_LINE_STORE_REQUEST:
      return {
        ...state,
        transferlineDetail: action.transferLineStoreData,
      };
    case GET_TRANSFER_LINE_RESET_REQUEST:
      return {
        ...initialState
      };
    case GET_TRANSFER_LINE_DETAIL_INSTRUCTION_REQUEST:
      return {
        ...state,
        isSaving: true
      };
    case GET_TRANSFER_LINE_DETAIL_INSTRUCTION_SUCCESS:
      return {
        ...state,
        isSaving: false,
        formDataDetail: action.data
      };
    case GET_TRANSFER_LINE_DETAIL_INSTRUCTION_FAILURE:
      return {
        ...state,
        isSaving: false
      };
    case TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorDocuments: ''
      }
    case TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorDocuments: PROFILE_ERROR_CODE[action.error?.response?.data?.code]
      }
    case TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorDocuments: '',
        documentRepo: {
          ...state.documentRepo,
          ...action.data
        }
      }

    case TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorDocuments: PROFILE_ERROR_CODE[action.error.response?.data?.code]
      }

    case TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_SUCCESS: {
      const { documentRepo } = action.data;
      return {
        ...state,
        isLoading: false,
        errorDocuments: '',
        documentRepo
      }
    }
    case TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorDocuments: PROFILE_ERROR_CODE['INTERNAL-SERVER-ERROR']
      }

    case GET_TRANSFER_LINE_ORDER_SUBMIT_SUCCESS:
      return {
        ...state,
        orderDetail: action.data.orderId,
        orderTime: action.data.orderUpdateTime
      };

    case GET_TRANSFER_LINE_PERSONAL_PLANS_SUCCESS:
      return {
        ...state,
        personalPlans: action.data
      };
    case GET_TRANSFER_LINE_PERSONAL_PLANS_REQUEST:
    case GET_TRANSFER_LINE_PERSONAL_PLANS_FAILURE:
      return {
        ...state
      }
    default:
      return state;
  }
};
export default transferLineReducers;
